import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {ReachEmailSpamCheckStartRequest, ReachEmailSpamCheckStartResponse} from "./types";

const startEmailSpamCheck = async (variables: ReachEmailSpamCheckStartRequest): Promise<ReachEmailSpamCheckStartResponse> => {
  const response = await axiosReachInstance.post<
    ReachEmailSpamCheckStartResponse,
    AxiosResponse<ReachEmailSpamCheckStartResponse>,
    ReachEmailSpamCheckStartRequest
  >("/templates/spam-check", variables);
  return response.data;
};

export const useStartEmailSpamCheck = (
  options?: BaseMutationOptions<ReachEmailSpamCheckStartResponse, ReachEmailSpamCheckStartRequest>
): BaseUseMutationResult<ReachEmailSpamCheckStartResponse, ReachEmailSpamCheckStartRequest> =>
  useBaseMutation<ReachEmailSpamCheckStartResponse, ReachEmailSpamCheckStartRequest>(startEmailSpamCheck, options);
